import {useTranslation} from 'react-i18next'
import moment from 'moment'
import {DEFAULT_FILTER_RANGE_DAYS, getDefaultFilterStartDate} from 'util/date'

const date = new Date();
export const InitialState = {
  total: {
    total_amounts: 0,
    total_cods_signed: 0,
    total_orders: 0,
    total_orders_signed: 0,
  },
  SelectedDuration: {label: 'for_week', value: 'for_week'},
  date_end : moment(date).format("YYYY-MM-DD"),
  // Mặc định 7 ngày: hôm nay + 6 ngày trước
  date_start: moment(getDefaultFilterStartDate()).format("YYYY-MM-DD"),
  day: DEFAULT_FILTER_RANGE_DAYS,
  bannerPopup:{
    banner:[],
    popup:[]
  },
  productQuantity:{
    purchase_date: '',
    total_products:0,
  }
}
